import {RoomLms} from "@/core/api/room.lms.api";

export default {
    getLmsUserList: async ({ commit }) => {
        const { data } = await RoomLms.getLmsUserList();
        commit('SET_LMS_USER_LIST', data);
        return data;
    },
    sendSMSToLmsUser: async ({}, params) => {
        return await RoomLms.sendSMSToLmsUser(params);
    },
    sendSMSToAllLmsUser: async ({}, params) => {
        return await RoomLms.sendSMSToAllLmsUser(params);
    }
}
